(function () {
  function initProductSlider(slider) {
    if (!slider) return;

    /*
     * Prevent duplicate Swiper instances.
     *
     * Important for:
     * - normal page load
     * - Shopify Theme Editor
     * - section reload
     */
    if (slider.swiper) {
      return;
    }

    if (typeof Swiper === 'undefined') {
      return;
    }

    const showArrows = slider.dataset.showArrows === 'true';
    const showDots = slider.dataset.showDots === 'true';

    const nextButton = slider.querySelector('.swiper-button-next');
    const prevButton = slider.querySelector('.swiper-button-prev');
    const paginationElement = slider.querySelector('.swiper-pagination');

    const swiperOptions = {
      slidesPerView: 2,
      spaceBetween: 15,

      speed: 400,

      watchOverflow: true,
      observer: true,
      observeParents: true,

      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 15
        },

        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },

        1200: {
          slidesPerView: 4,
          spaceBetween: 30
        }
      }
    };

    /*
     * Enable arrows only when selected
     * from Shopify customizer.
     */
    if (
      showArrows &&
      nextButton &&
      prevButton
    ) {
      swiperOptions.navigation = {
        nextEl: nextButton,
        prevEl: prevButton
      };
    }

    /*
     * Enable pagination dots only when selected
     * from Shopify customizer.
     */
    if (
      showDots &&
      paginationElement
    ) {
      swiperOptions.pagination = {
        el: paginationElement,
        clickable: true
      };
    }

    new Swiper(slider, swiperOptions);
  }


  function initAllProductSliders(container) {
    const scope = container || document;

    const sliders = scope.querySelectorAll(
      '[data-product-slider]'
    );

    sliders.forEach(function (slider) {
      initProductSlider(slider);
    });
  }


  /*
   * Standard page load
   */
  function initOnLoad() {
    initAllProductSliders(document);
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initOnLoad
    );
  } else {
    initOnLoad();
  }


  /*
   * Shopify Theme Editor support.
   *
   * When a section is added/reloaded dynamically,
   * DOMContentLoaded does not fire again.
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAllProductSliders(event.target);
    }
  );


  /*
   * Size selector
   */
  document.addEventListener('click', function (event) {
    const sizeButton = event.target.closest(
      '[data-size-option]'
    );

    if (!sizeButton) return;
    if (sizeButton.disabled) return;

    const productId = sizeButton.dataset.productId;
    const variantId = sizeButton.dataset.variantId;

    if (!productId || !variantId) return;

    const card = sizeButton.closest('.card-wrapper');

    if (!card) return;


    /*
     * Remove selected state from all size buttons
     * inside this product card.
     */
    const sizeButtons = card.querySelectorAll(
      '[data-size-option]'
    );

    sizeButtons.forEach(function (button) {
      button.classList.remove('selected');

      button.setAttribute(
        'aria-pressed',
        'false'
      );
    });


    /*
     * Select clicked size.
     */
    sizeButton.classList.add('selected');

    sizeButton.setAttribute(
      'aria-pressed',
      'true'
    );


    /*
     * Update variant input used by Quick Add.
     */
    const variantInput = card.querySelector(
      '[data-quick-add-variant-input]'
    );

    if (variantInput) {
      variantInput.value = variantId;

      variantInput.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }


    /*
     * Enable Add to Cart button.
     */
    const quickAddButton = card.querySelector(
      '[data-quick-add-button]'
    );

    if (quickAddButton) {
      quickAddButton.disabled = false;
    }
  });
})();